import { application } from "./application"

import ListingsMapController from "./listings_map_controller"
application.register("listings-map", ListingsMapController)

import ParcelEditorController from "./parcel_editor_controller"
application.register("parcel-editor", ParcelEditorController)

import ListingMapController from "./listing_map_controller"
application.register("listing-map", ListingMapController)

import ListingFormController from "./listing_form_controller"
application.register("listing-form", ListingFormController)
